import logger from '../logger'

import { default as xprops } from './xprops'
export { default as xprops } from './xprops'

export function loadXPropsMock() {
  if ((window as any).xprops) {
    logger.error('xprops_localhost_mock_overwriting_xprops', {
      err: 'no xprops.sessionState found - using dev stub',
    })
    throw new Error('xprops_localhost_mock_overwriting_xprops')
  }

  ;(window as any).xprops = xprops
}
